import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Geral
import { SelfAttendanceCancellationComponent } from './cancellation/cancellation.component';
import { RetentionPolicyComponent } from './retention-policy/retention-policy.component';
import { SelfAttendancePaymentChangeComponent } from './payment-change/payment-change.component';
import { SelfAttendanceSuccessComponent } from './success/success.component';
import { SelfAttendanceUpgradeComponent } from './upgrade/upgrade.component';
import { SelfAttendanceProcessingComponent } from './processing/processing.component';

// Consulta e Cobrança de Dívidas
import { SelfAttendanceAutoRechargeChangeComponent } from './auto-recharge/auto-recharge-change/auto-recharge-change.component';
import { SelfAttendanceAutoRechargeDisableComponent } from './auto-recharge/auto-recharge-disable/auto-recharge-disable.component';
import { SelfAttendanceAutoRechargePaymentComponent } from './auto-recharge/auto-recharge-payment/auto-recharge-payment.component';


import { SelfAttendanceComponent } from './self-attendance.component';
import {SelfAttendanceAutoRechargePaymentChangeComponent} from "./auto-recharge/payment-change/auto-recharge-payment-change.component";
import { SelfAttendanceEarlyRenewalComponent } from './early-renewal/early-renewal.component';

export const selfAttendanceRoutes: Routes = [
  {
    path: ':classificationIdentifier',
    component: SelfAttendanceComponent,
    children: [
      {
        path: 'cancelamento',
        component: SelfAttendanceCancellationComponent
      },
      {
        path: 'alteracao-de-pagamento',
        component: SelfAttendancePaymentChangeComponent
      },
      {
        path: 'sucesso',
        component: SelfAttendanceSuccessComponent
      },
      {
        path: 'upgrade',
        component: SelfAttendanceUpgradeComponent
      },
      {
        path: 'processando',
        component: SelfAttendanceProcessingComponent
      },
      {
        path: 'alterar-recarga-garantida',
        component: SelfAttendanceAutoRechargeChangeComponent
      },
      {
        path: 'desativar-recarga-garantida',
        component: SelfAttendanceAutoRechargeDisableComponent
      },
      // TODO - Talvez deveríamos ter um outro aquivo routing dentro de auto-recharge-enable para configurar as subrotas
      {
        path: 'recarga-garantida/pagamento',
        component: SelfAttendanceAutoRechargePaymentComponent
      },
      {
        path: 'recarga-garantida/alteracao-de-pagamento',
        component: SelfAttendanceAutoRechargePaymentChangeComponent
      },
      {
        path: 'cancelamento/retencao',
        component: RetentionPolicyComponent
      },
      {
        path: 'renovacao-antecipada',
        component: SelfAttendanceEarlyRenewalComponent
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/404'
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(selfAttendanceRoutes)
  ],
  exports: [RouterModule]
})

export class SelfAttendanceRoutingModule {}
